export default require("../../node_modules/.pnpm/react-keyed-flatten-children@1.3.0_react@17.0.2/node_modules/react-keyed-flatten-children/index.js");